<template>
  <div
    class="unsubscribe-block"
  >
    <template v-if="didUnsubscribe && !showUnsubscribeError && !hasRegretSuccess">
      <p>
        Du kommer inte längre få den här typen av mejl från ICA. Prenumerationen till <span class="unsubscribe-block__email">{{ email }}</span> är avslutad.
      </p>

      <p>
        Ångrat dig?
        <button
          class="unsubscribe-block__button link"
          :disabled="disableSubscribeAgain"
          type="button"
          @click="subscribeAgain"
        >
          Fortsätt prenumerera.
        </button>
      </p>
    </template>

    <transition name="unsubscribe-block__fade1">
      <p v-if="hasRegretSuccess">
        Hurra! Du kommer nu fortsätta få den här typen av mejl från ICA.
      </p>
    </transition>

    <transition name="unsubscribe-block__fade1">
      <technical-error
        v-if="showUnsubscribeError"
      >
        <span
          slot="message"
        >
          Vi upplever just nu tekniska problem. Du kan istället logga in och gå till dina inställningar för att <a href="/mitt-konto/">ändra vilka utskick du får</a>.
        </span>
      </technical-error>
    </transition>

    <transition name="unsubscribe-block__fade1">
      <technical-error
        v-if="showResubscribeError"
      >
        <span
          slot="message"
        >
          Vi upplever just nu tekniska problem. Du kan istället logga in och gå till dina inställningar för att <a href="/mitt-konto/">ändra vilka utskick du får</a>.
        </span>
      </technical-error>
    </transition>
  </div>
</template>

<script>
import dataLayer from '@/analytics/dataLayer.js'

/**
 * https://davidwalsh.name/query-string-javascript
 */
function getUrlParameter (name) {
  const search = window.location.search
  try {
    const urlParams = new URLSearchParams(search)
    return urlParams.get(name)
  } catch (error) {
    // IE11 has no URLSearchParams
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
    const results = regex.exec(search)
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
  }
}

export default {
  name: "UnsubscribeBlock",
  data (){
    return {
      didUnsubscribe: false,
      email: '',
      errorHeader: 'Hoppsan, tekniskt fel',
      disableSubscribeAgain: false,
      showUnsubscribeError: false,
      showResubscribeError: false,
      subscribeToken: '',
      hasRegretSuccess: false,
      subscribeUrl: '/api/subscriptions/unsubscribe/regret',
    }
  },
  mounted () {
    this.email =   this.getEmail()
    this.subscribeToken = this.getToken()
    const error = this.getErrorFromUnsubscribe()
    this.didUnsubscribe = !error
},
  methods:{
    getEmail () {
      const email = getUrlParameter('email')
      if(!email){
        this.showUnsubscribeError = true
        console.error('No email in query')
      }
      return email
    },
    getErrorFromUnsubscribe () {
      const error = getUrlParameter('error')
      if(!error){
        return false
      }
      this.showUnsubscribeError = true
      return error
    },
    getToken () {
      const token = getUrlParameter('regretToken')
      if(!token){
        this.showUnsubscribeError = true
        console.error('No token in query')
      }
      return token
    },
   subscribeAgain () {
     this.disableSubscribeAgain = true
      fetch(this.subscribeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.subscribeToken)
      }).then(response => {
        if (response.status >= 200 && response.status < 300) {
          this.hasRegretSuccess = true
          this.disableSubscribeAgain = false
          dataLayer.add({
            event: "cpcAddEmail",
            cpcVpvUrl: "utskick-fran-ica"
          })
        } else {
          this.hasRegretSuccess = false
          this.showResubscribeError = true
          this.disableSubscribeAgain = true
        }
      }).catch(error => {
        console.error(error)
          this.showResubscribeError = true
          this.disableSubscribeAgain = false
      })
    }
  }
}
</script>

<style lang="scss">
.unsubscribe-block {
  padding: 0 1.5rem 1.5rem 1.5rem;
  margin-bottom: 0.5rem;

  @include media-breakpoint-up(md) {
    padding: 0 2.5rem 2rem 2.5rem;
  }

  p {
    margin-top: 0;
  }

  &__email {
    color: $color-primary-cta;
  }

  &__button {
    font-size: inherit;
  }

  &__fade1-enter-active {
    transition: opacity 0.5s;
  }

  &__fade1-enter {
    opacity: 0;
  }
}
</style>
